import { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconSalesforce = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M9.13087 6.02729L9.83886 6.95586L10.6475 6.11348C11.2385 5.49788 12.0536 5.12236 12.9509 5.12236C14.1412 5.12236 15.1929 5.78516 15.7586 6.79337L16.2052 7.58929L17.0386 7.21706C17.5643 6.9822 18.1338 6.86115 18.7097 6.86184H18.7109C20.9901 6.86184 22.8526 8.72804 22.8526 11.0492C22.8526 13.3704 20.9901 15.2366 18.7109 15.2366C18.4305 15.2366 18.1581 15.2086 17.8953 15.1556L17.1816 15.0118L16.8254 15.6468C16.3508 16.4933 15.4486 17.0609 14.4164 17.0609C13.9815 17.0609 13.5736 16.9612 13.2116 16.7841L12.2644 16.3207L11.8519 17.2911C11.3499 18.472 10.1817 19.2958 8.82418 19.2958C7.41069 19.2958 6.202 18.4015 5.73805 17.1427L5.4391 16.3316L4.59328 16.5101C4.39216 16.5525 4.18718 16.5739 3.98164 16.5738H3.98128C2.34455 16.574 1.00001 15.2306 1.00001 13.5512L1.00001 13.5489C0.998768 13.0196 1.13629 12.4992 1.39887 12.0395L0.530585 11.5435L1.39887 12.0395C1.66145 11.5799 2.03991 11.1972 2.49653 10.9294L3.26072 10.4813L2.90804 9.66868C2.71075 9.21407 2.60923 8.72368 2.60984 8.2281V8.22688C2.60984 6.22494 4.23505 4.6001 6.24262 4.6001L6.24379 4.6001C6.80245 4.59945 7.3537 4.72792 7.85452 4.97549C8.35533 5.22306 8.79215 5.58303 9.13087 6.02729Z"
      stroke="currentColor"
      strokeWidth="2"
    />
  </SvgIcon>
));
